import axios from 'axios';

const rules = {
    'validar_cuit': {
        rules: {
            getMessage: () => `El CUIT es inválido`,
            validate: value => new Promise((resolve) => {
                this.$http.post('cliente/validar-cuit', {cuit: value})
                    .then(r => {
                        resolve({valid: r.data});
                    })
                    .catch(e => {
                        resolve({valid: false});
                    })
            })
        },
        paramNames: ''
    },
    'mayor': {
        rules: {
            getMessage: field => 'El campo ' + field + ' debe poseer un valor mayor a 0.',
            validate: value => value > 0
        },
        paramNames: ''
    },
    'descuento_com': {
        rules: {
            getMessage: (field, params, data) => {
                return (data && data.message) || `No posee los permisos necesarios para utilizar este monto de descuento`;
            },
            validate: (porcentaje, args) => new Promise((resolve) => {
                axios.post('precio/descuento-comercial', {
                    porcentaje: porcentaje,
                    producto: args[0],
                    presup_item: args[1]
                })
                    .then(r => {
                        resolve(r.data);
                    })
                    .catch(e => {
                        resolve({valid: false});
                    })
            })
        },
        paramNames: ['producto', 'presup_item']

    },
    'descuento_est': {
        rules: {
            getMessage: (field, params, data) => {
                return (data && data.message) || `No posee los permisos necesarios para utilizar este monto de descuento`;
            },
            validate: (porcentaje, args) => new Promise((resolve) => {
                axios.post('precio/descuento-estrategico', {
                    porcentaje: porcentaje,
                    producto: args[0],
                    presup_item: args[1]
                })
                    .then(r => {
                        resolve(r.data);
                    })
                    .catch(e => {
                        resolve({valid: false});
                    })
            })
        },
        paramNames: ['producto', 'presup_item']

    }
};
// export an 'install' function.
export default (Validator) => {
    // for every rule we defined above.
    Object.keys(rules).forEach(rule => {
        //  add the rule.
        let paramNames = rules[rule].paramNames;
        Validator.extend(rule, rules[rule].rules, {paramNames});
    });
};


// WEBPACK FOOTER //
// ./resources/assets/js/validation/rules.js